// extracted by mini-css-extract-plugin
export default {"button-container":"VCardDownloader_button-container__uk-eS","download-btn":"VCardDownloader_download-btn__uMPmw","secondary-btn":"VCardDownloader_secondary-btn__Mzzzt"};